import { useQuery, useMutation } from '@tanstack/react-query';

import {
  API_PUBLIC_SNAPSHOT,
  API_SNAPSHOT_SIGNUP,
} from 'constants/constants';
import { buildUrl } from 'utils/utils';

export const publicSnapshotKeys = {
  all: ['publicSnapshot'],
  detail: (id) => [...publicSnapshotKeys.all, `${id}`]
};

export const usePublicSnapshot = (uuid, { onSuccess, onError }) => {
  return useQuery({
    queryKey: publicSnapshotKeys.detail(uuid),
    queryFn: async () => {
      const url = buildUrl(API_PUBLIC_SNAPSHOT, [{ name: 'uuid', value: uuid }]);
      const res = await fetch(url);
      if (!res.ok) throw Error('Load failed');
      return res.json();
    },
    initialData: {
      conversation_data: {
        messages: [],
        llm_models: [],
      },
    },
    onSuccess,
    onError
  });
};

export const useSnapshotSignupMutation = () => {
  return useMutation(async (data) => {
    const url = buildUrl(API_SNAPSHOT_SIGNUP);
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    return res.json();
  });
};
